import { render, staticRenderFns } from "./ProofLeaderActions.vue?vue&type=template&id=ccf360c6"
import script from "./ProofLeaderActions.vue?vue&type=script&lang=js"
export * from "./ProofLeaderActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports